<script setup lang="ts">
import { computed } from 'vue';
import { DgrIcon, DgrPopover } from '@stockmarkteam/donguri-ui';
import { Comment } from '@/types';
import { useUserInfo } from '@/utils/swr';

const props = defineProps<{
  comment: Comment;
}>();

const emit = defineEmits<{
  'edit-comment': [comment: Comment];
  'delete-comment': [comment: Comment];
}>();

const { data: userInfo } = useUserInfo();

const hasEditPermission = computed(
  () => userInfo.value?.id === props.comment.user_id,
);
const hasDeletePermission = computed(
  () =>
    userInfo.value?.role === 'admin' ||
    userInfo.value?.id === props.comment.user_id,
);

const openCommentEditModal = () => {
  emit('edit-comment', props.comment);
};

const deleteComment = async () => {
  emit('delete-comment', props.comment);
};
</script>

<template>
  <div class="article-comment-menu">
    <DgrPopover>
      <template #default="{ triggerProps }">
        <button
          class="ellipsis-button"
          v-if="hasEditPermission || hasDeletePermission"
          v-bind="triggerProps"
        >
          <DgrIcon size="small" name="ellipsis-h" />
        </button>
        <div class="spacing-24" v-else></div>
      </template>
      <template #content="{ close }">
        <div class="comment-menu-body comment-menu-small c-text-regular--m">
          <div
            class="comment-edit"
            v-if="hasEditPermission"
            @click="
              openCommentEditModal();
              close();
            "
          >
            コメントを編集
          </div>
          <div
            class="comment-delete"
            v-if="hasDeletePermission"
            @click="
              deleteComment();
              close();
            "
          >
            コメントを削除
          </div>
        </div>
      </template>
    </DgrPopover>
  </div>
</template>

<style lang="scss" scoped>
.article-comment-menu {
  .ellipsis-button {
    height: 32px;
    width: 32px;
    padding: 8px;
    border-radius: 4px;
    border: none;
    background: none;
    &:hover {
      background: $color-gray400;
    }
  }
}

.comment-menu-body {
  padding: 12px 0;
  background: #ffffff;

  .comment-edit,
  .comment-delete {
    padding: 2px 12px;
    cursor: pointer;
    &:hover {
      background-color: $color-gray200;
    }
  }

  .comment-delete {
    color: $color-orange1000;
  }
}
</style>
